import { __spreadArray } from "tslib";
import { useRef } from 'react';
var invalidHookCallRe = /invalid hook call/i;
var seen = new Set();
export var checkDynamicCreation = function (displayName, componentId) {
    if (process.env.NODE_ENV !== 'production') {
        var parsedIdString = componentId ? " with the id of \"".concat(componentId, "\"") : '';
        var message_1 = "The component ".concat(displayName).concat(parsedIdString, " has been created dynamically.\n") +
            "You may see this warning because you've called styled inside another component.\n" +
            'To resolve this only create new StyledComponents outside of any render method and function component.';
        // If a hook is called outside of a component:
        // React 17 and earlier throw an error
        // React 18 and above use console.error
        var originalConsoleError_1 = console.error;
        try {
            var didNotCallInvalidHook_1 = true;
            console.error = function (consoleErrorMessage) {
                var consoleErrorArgs = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    consoleErrorArgs[_i - 1] = arguments[_i];
                }
                // The error here is expected, since we're expecting anything that uses `checkDynamicCreation` to
                // be called outside of a React component.
                if (invalidHookCallRe.test(consoleErrorMessage)) {
                    didNotCallInvalidHook_1 = false;
                    // This shouldn't happen, but resets `warningSeen` if we had this error happen intermittently
                    seen.delete(message_1);
                }
                else {
                    originalConsoleError_1.apply(void 0, __spreadArray([consoleErrorMessage], consoleErrorArgs, false));
                }
            };
            // We purposefully call `useRef` outside of a component and expect it to throw
            // If it doesn't, then we're inside another component.
            useRef();
            if (didNotCallInvalidHook_1 && !seen.has(message_1)) {
                console.warn(message_1);
                seen.add(message_1);
            }
        }
        catch (error) {
            // The error here is expected, since we're expecting anything that uses `checkDynamicCreation` to
            // be called outside of a React component.
            if (invalidHookCallRe.test(error.message)) {
                // This shouldn't happen, but resets `warningSeen` if we had this error happen intermittently
                seen.delete(message_1);
            }
        }
        finally {
            console.error = originalConsoleError_1;
        }
    }
};
//# sourceMappingURL=checkDynamicCreation.js.map